// 外观模块
export default {
    Appearance: {
        MobilePhone: 'Mobile Phone', 
        Computer: 'Computer',
        AppearanceSettings: 'Appearance Settings',
        Header: 'Header',
        ShowHeader: 'Show Header',
        HeaderType: 'Header Type',
        Writing: 'Writing',
        Single: 'Single',
        TextContent: 'Text content',
        PleaseEnterContent: 'Please enter content',
        FontSettings: 'Font Settings',
        Align: 'Align',
        LeftJustifying: 'Align Left',
        Center: 'Center',
        RightAlignment: 'Align Right',
        bgColor: 'Background color',
        HeaderImage: 'Header Image',
        AddPicture: 'Add Picture',
        Background: 'Background',
        BackgroundSettings: 'Background Settings',
        Pictures: 'Pictures',
        ChooseAColor: 'Choose a Color',
        BackgroundImage: 'Background Image',
        BackgroundPosition: 'Background Position',
        Tile: 'Tile',
        BackgroundTransparency: 'Background Transparency',
        LogoSettings: 'Logo Settings',
        LogoLocation: 'Logo Location',
        ProjectTitle: 'Project Title',
        WelcomeMessage: 'Welcome Message',
        Stem: 'Stem',
        Option: 'Option',
        Conclusion: 'Conclusion',
        ButtonSettings: 'Button Settings',
        SubmitButtonText: 'Submit Button Text',
        DisplaySettings: 'Display Settings',
        ShowHeading: 'Show Heading',
        ShowWelcomeMessage: 'Show Welcome Message',
        DisplayQuestionNumber: 'Display Question Number',
        SubmitTo: 'Submit to'
    },
  };